import { useEffect, useState } from 'react';

let hasInitialized = false;

export const useMPCWidget = () => {
  const [addresses, setAddresses] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasAccount, setHasAccount] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const widgetElement = document.getElementById('mpc-widget');

      if (widgetElement && window.MPCWidget && !hasInitialized) {
        clearInterval(interval);
        hasInitialized = true;

        window.MPCWidget?.renderWidget(widgetElement, {
          baseUrl: process.env.WIDGET_BASE_URL || 'http://localhost:3000',
          redirectUrl:
            process.env.WIDGET_REDIRECT_URL || 'http://localhost:3000',
          stytchPublicToken:
            process.env.STYTCH_PUBLIC_TOKEN ||
            'public-token-test-910c8b48-7956-42b5-9574-252842707fc4',
          onGetAddresses: newAddresses => {
            console.log('onGetAddresses', newAddresses);
            setAddresses(newAddresses);
          },
          onGetBalance: newBalances => {
            console.log('onGetBalance', newBalances);
          },
          onWidgetOpenChange: isOpen => {
            console.log('onWidgetOpenChange', isOpen);
          },
          widgetOpen: widgetOpen => {
            console.log('widgetOpen', widgetOpen);
          },
        });
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const checkMPCWidget = () => {
      if (window.MPCWidget) {
        setIsLoading(window.MPCWidget.isLoading);
        setHasAccount(window.MPCWidget.hasAccount);
        setUser(window.MPCWidget?.user);
      }
    };

    checkMPCWidget();

    const interval = setInterval(() => {
      if (window.MPCWidget) {
        checkMPCWidget();
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const handleLoginClick = () => {
    if (window.MPCWidget) {
      window.MPCWidget.login();
    } else {
      window.open('https://accounts.bitcoin.com/signin/', '_blank');
    }
  };

  return {
    addresses,
    isLoading,
    hasAccount,
    user,
    handleLoginClick,
  };
};
